import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-page-well',
    imports: [
        CommonModule
    ],
    templateUrl: './page-well.component.html',
    styleUrls: ['./page-well.component.scss']
})
export class PageWellComponent {
  @Input() showBorder: boolean = true;
  @Input() noPaddingMobile: boolean = false;
}
